<div class="container-fluid">
  <div class="row">
    <header id="header" class="navbar bg-white flex-md-nowrap sticky-top">
      <a class="navbar-brand px-2" href="#">
        <img src="assets/images/nhso.png" alt="logo" height="35">
      </a>
      <a class="text-decoration-none text-black fw-semibold ">
        ระบบศูนย์กลางบริการระบบงานขึ้นทะเบียน (e-Portal)
      </a>
      <div class="dropdown text-end mx-2">
        <a href="#" class="d-block link-body-emphasis text-decoration-none dropdown-toggle"
           data-bs-toggle="dropdown" aria-expanded="false">
          {{ principalName }}
        </a>
        <ul class="dropdown-menu dropdown-menu-start text-small" style="">
          <li><a class="dropdown-item"><i class="bi bi-person me-2"></i>โปรไฟล์</a></li>
          <li><a class="dropdown-item"><i class="bi bi-box-arrow-in-right me-2"></i>ออกจากระบบ</a></li>
        </ul>
      </div>

      <ul class="navbar-nav flex-row d-md-none">
        <li class="nav-item text-nowrap">
          <button class="nav-link px-3"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#sidebar-menu" aria-controls="sidebar-menu" aria-expanded="false"
                  aria-label="Toggle navigation">
            <span class="bi bi-list"></span>
          </button>
        </li>
      </ul>
    </header>
    <!--    <div class="d-none d-md-flex justify-content-end me-3 flex-wrap flex-md-nowrap align-items-center">-->
    <!--      <ul class="list-group list-group-horizontal-sm rounded-0 border-0">-->
    <!--        <li id="defaultFontSize14px" class="list-group-item list-group-item-action align-middle active"-->
    <!--            (click)="setFontSizeTo('14px')">ก-->
    <!--        </li>-->
    <!--        <li id="defaultFontSize16px" class="list-group-item list-group-item-action align-middle"-->
    <!--            (click)="setFontSizeTo('16px')">ก+-->
    <!--        </li>-->
    <!--        <li id="defaultFontSize18px" class="list-group-item list-group-item-action align-middle"-->
    <!--            (click)="setFontSizeTo('18px')">ก+-->
    <!--        </li>-->
    <!--      </ul>-->
    <!--    </div>-->
  </div>
</div>
<div class="container">
  <div class="row mb-3 my-4">
    <h6>ระบบลงทะเบียนสำนักงานหลักประกันสุขภาพแห่งชาติ</h6>
  </div>
  <div class="row align-items-stretch mb-3 g-3">
    <div class="col-xl-3 col-6">
      <div routerLink="/secure/right-search" class="custom-card card-body">
        <div class=" p-4 rounded-4 text-white clearfix">
          <div class="card-text">
            <h6 class=" text-truncate">ตรวจสอบสิทธิ</h6>
            <h6 class=" text-truncate">และลงทะเบียนประชาชน</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card card-body">
        <div class=" p-4 rounded-4 text-white clearfix">
          <div class="card-text">
            <h6 class=" text-truncate">ตรวจสอบสิทธิแบบกลุ่ม</h6>
            <h6 class=" text-truncate">&nbsp;</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card card-body">
        <div class=" p-4 rounded-4 text-white clearfix">
          <div class="card-text">
            <h6 class=" text-truncate">แก้ไขสิทธิรักษาพยาบาบาล</h6>
            <h6 class="">ของประชาชน (ปรับปรุงสิทธิ)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card card-body">
        <div class=" p-4 rounded-4 text-white clearfix">
          <div class="card-text">
            <h6 class="">บริหารจัดการผู้ใช้งาน</h6>
            <h6 class=" text-truncate">&nbsp;</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card card-body">
        <div class=" p-4 rounded-4 text-white clearfix">
          <div class="card-text">
            <h6 class="">ระบบ Download ข้อมูลทะเบียน</h6>
            <h6 class=" text-truncate">&nbsp;</h6>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="my-5"></div>
  <div class="row align-items-stretch mb-3 g-3">
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class="">ระบบตรวจสอบและยืนยันการเข้ารับบริการ (New Authen Code)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class=" text-truncate">ระบบขอเลขอนุมัติเบิกจ่ายตรง</h6>
            <h6 class="">(สำหรับกองทุนอื่น)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class="">ระบบบันทึกข้อมูลผู้มีสิทธิ</h6>
            <h6 class="">(อปท./รัฐวิสาหกิจ)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class="">ระบบบันทึกเบิกค่ารักษาพยาบาลด้วยใบเสร็จ (ข้าราชการ)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class="">ระบบค้นหาเครือข่ายหน่วยบริการ</h6>
            <h6 class=" text-truncate">(New MasterCup)</h6>
          </div>

        </div>
      </div>
    </div>
    <div class="col-xl-3 col-6">
      <div (click)="notImplementedYet()" class="custom-card2 card-body">
        <div class=" p-4 rounded-4  clearfix">
          <div class="card-text">
            <h6 class="">ระบบค้นหาข้อมูลหน่วยบริการ</h6>
            <h6 class=" text-truncate">สำหรับประชาชน</h6>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
